import React from 'react'
import { useTranslation } from 'react-i18next'
import { Table } from '@dataplace.ai/ui-components/organisms'
import { NoPrint } from '@dataplace.ai/ui-components/atoms'
import { SeeMoreWrapper, StyledButton, StyledSpan, SubTitle } from './WellFitPotentialModelResult.styles'

interface IAdditionalRanking {
  additionalRankingOpen: boolean
  setAdditionalRankingOpen: React.Dispatch<React.SetStateAction<boolean>>
  tableContent: JSX.Element[][];
}

export const AdditionalRanking: React.FC<IAdditionalRanking> = ({
  additionalRankingOpen,
  setAdditionalRankingOpen,
  tableContent,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {
        additionalRankingOpen
          ? (
            <>
              <SubTitle $borderTop>
                {t('placeme.well_fit_potential.addition_rank.title')}
              </SubTitle>
              <Table
                buildings
                content={tableContent}
                gap='1rem'
                headerTemplate='5fr 1fr 2fr'
                justifyFirstChildRight
                labels={[
                  t('placeme.well_fit_potential.addition_rank.label1'),
                  t('placeme.well_fit_potential.addition_rank.label2'),
                  t('placeme.well_fit_potential.addition_rank.label3'),
                ]}
                rowTemplate='5fr 1fr 2fr'
              />
            </>
          )
          : (
            <NoPrint>
              <SeeMoreWrapper>
                <StyledSpan>{t('placeme.well_fit_potential.addition_rank.span')}</StyledSpan>
                <StyledButton onClick={() => setAdditionalRankingOpen(true)}>
                  {t('placeme.well_fit_potential.addition_rank.button_text')}
                </StyledButton>
              </SeeMoreWrapper>
            </NoPrint>
          )
      }
    </>
  )
}
